export default __webpack_public_path__ + "static/media/Herberh2.3675419c.png";